var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"APPOINTMENT-BUBBLE ellipsize",class:{ 'ACTIVE': _vm.active },attrs:{"selenium":`current-job-appointment`}},[_vm._v("\n  "+_vm._s(_vm.appointmentText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }